<template>
  <div class="page-container" :class="{ 'login-active': showLogin }">
    
    <div class="main-bg" :style="{ '--bg-image': 'url(/img/Fondo.png)', '--bg-mobile': 'url(/img/FondoMobil.png)' }">
      <div class="main-overlay"></div>
    </div>

    <div class="welcome-layer" :class="{ 'mobile-hidden': showLogin }">
      <div class="welcome-content px-4 md:px-0" :class="{ 'fade-out': showLogin }">
        <div class="brand-tag">
          <span class="line"></span> BIENVENIDO <span class="line"></span>
        </div>
        <h1 class="brand-title">KURDA<span>MOVIL</span><small class="hidden sm:inline-block">APP</small></h1>
        <p class="brand-slogan">
          "Donde hay <strong>control</strong>, hay eficiencia operativa."
        </p>
        
        <div class="system-info-grid mt-10 mb-4">
          <div class="info-item">
            <div class="info-icon-wrapper">
              <i class="fas fa-boxes"></i>
            </div>
            <div>
              <h4 class="text-white text-sm font-bold uppercase tracking-wider">Gestión de Inventario</h4>
              <p class="text-gray-300 text-xs">Control de stock y movimientos en tiempo real.</p>
            </div>
          </div>
          
          <div class="info-item">
            <div class="info-icon-wrapper">
              <i class="fas fa-user-friends"></i>
            </div>
            <div>
              <h4 class="text-white text-sm font-bold uppercase tracking-wider">Cartera de clientes</h4>
              <p class="text-gray-300 text-xs">Gestión integral de información de clientes.</p>
            </div>
          </div>

          <div class="info-item">
            <div class="info-icon-wrapper">
              <i class="fas fa-file-invoice-dollar"></i>
            </div>
            <div>
              <h4 class="text-white text-sm font-bold uppercase tracking-wider">Módulo de Ventas</h4>
              <p class="text-gray-300 text-xs">Control de pedidos y seguimiento de ventas.</p>
            </div>
          </div>

          <div class="info-item">
            <div class="info-icon-wrapper">
              <i class="fas fa-shield-alt"></i>
            </div>
            <div>
              <h4 class="text-white text-sm font-bold uppercase tracking-wider">Acceso Seguro</h4>
              <p class="text-gray-300 text-xs">Protección de datos y control de permisos.</p>
            </div>
          </div>
        </div>
        
        <div class="container-btn-ingresar">
          <button @click="showLogin = true" class="btn-reveal-login">
            <span>INGRESAR AL SISTEMA</span>
            <i class="fas fa-arrow-right ml-3"></i>
          </button>
        </div>
      </div>
    </div>

    <transition name="slide-x">
      <div v-if="showLogin" class="login-panel">
        <div class="login-panel-content w-full flex justify-center items-center">
          
          <button @click="showLogin = false" class="btn-close-panel">
            <i class="fas fa-times mr-2"></i> CERRAR
          </button>

          <div class="login-box border-2 border-[#3b82f6] p-8 rounded-[2.5rem] bg-black/20 shadow-2xl backdrop-blur-md">
            <div class="card bg-transparent border-0 shadow-none">
              <div class="card-header text-center border-0">
                <a href="#" class="h1 text-white"><b>Kurda</b>Movil</a>
              </div><hr class="border-white/10 mb-4">
              <div class="card-body login-card-body bg-transparent text-white">
                <p class="login-box-msg font-weight-bold">Ingresa con tu cuenta</p>
                
                <form @submit.prevent="login">
                  <div class="input-group mb-4">
                    <input v-model="email" type="email" class="form-control custom-input" placeholder="Correo" required>
                    <div class="input-group-append">
                      <div class="input-group-text custom-append"><span class="fas fa-envelope text-primary"></span></div>
                    </div>
                  </div>
                  <div class="input-group mb-4">
                    <input v-model="password" type="password" class="form-control custom-input" placeholder="Contraseña" required>
                    <div class="input-group-append">
                      <div class="input-group-text custom-append"><span class="fas fa-lock text-primary"></span></div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <button type="submit" class="btn btn-primary btn-block py-3 font-weight-bold shadow-lg rounded-xl">
                        ENTRAR <i class="fas fa-sign-in-alt ml-2"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="text-center mt-5">
              <p class="text-white-50 text-[10px] uppercase tracking-widest italic">Kurdamovil APP v1.0 </p>
            </div>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<style scoped>
/* Estructura Base */
.page-container {
  position: relative;
  height: 100vh;
  width: 100%;
  overflow-y: auto; /* Cambio: Permite scroll si el contenido sobrepasa la pantalla */
  overflow-x: hidden;
  background-color: #000;
  display: flex;
}

/* En PC mantenemos el overflow hidden para que se vea estático y pro */
@media (min-width: 993px) {
  .page-container {
    overflow: hidden;
  }
}

.main-bg {
  position: absolute;
  inset: 0;
  background-image: var(--bg-image);
  background-size: cover;
  background-position: center;
  z-index: 0;
}

@media (max-width: 768px) {
  .main-bg {
    background-image: var(--bg-mobile);
  }
}

.main-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to right, 
    rgba(0, 0, 0, 0.95) 20%, 
    rgba(0, 15, 35, 0.7) 60%, 
    rgba(0, 5, 15, 0.4) 100%
  );
  z-index: 1;
}

/* Capa de Bienvenida */
.welcome-layer {
  position: relative;
  z-index: 10;
  flex: 1;
  display: flex;
  align-items: center; /* Centrado en PC */
  padding: 2rem 10%;
  transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}

.welcome-content {
  max-width: 600px;
  transition: opacity 0.4s ease, transform 0.6s ease;
}

.welcome-content.fade-out {
  opacity: 0.3;
  transform: translateX(-50px);
  filter: blur(2px);
}

/* Panel de Login */
.login-panel {
  position: absolute;
  right: 0;
  top: 0;
  height: 100vh;
  width: 500px;
  background: rgba(0, 15, 30, 0.7);
  backdrop-filter: blur(15px);
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  z-index: 20;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-panel-content {
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-box { width: 100%; max-width: 420px; margin: 0 20px; }

/* Botones y Estilos */
.btn-reveal-login {
  background: transparent;
  border: 2px solid #3b82f6;
  color: white;
  padding: 1rem 2rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  border-radius: 4px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.btn-reveal-login:hover {
  background: #3b82f6;
  box-shadow: 0 0 25px rgba(59, 130, 246, 0.5);
}

.btn-close-panel {
  position: absolute;
  top: 2rem;
  right: 2rem;
  background: none;
  border: none;
  color: #64748b;
  font-weight: bold;
  font-size: 0.7rem;
  letter-spacing: 0.2em;
  cursor: pointer;
}

.btn-close-panel:hover { color: white; }

.custom-input {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  color: white !important;
}

.custom-append {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
}

/* Tipografía */
.brand-tag { font-size: 1.1rem; font-weight: 800; letter-spacing: 0.5em; color: #3b82f6; text-transform: uppercase; margin-bottom: 1rem; display: flex; align-items: center; gap: 15px; }
.brand-tag .line { height: 2px; width: 30px; background: #3b82f6; display: inline-block; }
.brand-title { 
  font-size: 5rem; 
  font-weight: 900; 
  line-height: 0.9; 
  color: white; 
  letter-spacing: -3px; 
  text-shadow: 0 10px 30px rgba(0, 0, 0, 0.8);
}
.brand-title span { color: #3b82f6; }
.brand-title small { font-size: 1.5rem; vertical-align: top; color: #3b82f6; letter-spacing: 2px; margin-left: 4px; font-weight: 300; border: 1px solid #3b82f6; padding: 2px 8px; border-radius: 4px; }
.brand-slogan { 
  font-size: 1.5rem; 
  color: #e2e8f0; 
  font-style: italic; 
  border-left: 4px solid #3b82f6; 
  padding-left: 1.5rem; 
  margin-top: 1.5rem; 
  text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
}

.system-info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 25px;
  max-width: 550px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  padding: 18px;
  border-radius: 15px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.info-item:hover {
  transform: translateY(-5px);
  background: rgba(255, 255, 255, 0.07);
}

.info-item h4 {
  color: #ffffff !important;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.5);
}

.info-item p {
  color: #d1d5db !important;
  font-weight: 400;
}

.info-item i {
  font-size: 1.2rem;
  margin-top: 3px;
}

.info-icon-wrapper {
  width: 45px;
  height: 45px;
  background: rgba(59, 130, 246, 0.15);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.info-icon-wrapper i {
  color: #ffffff !important;
  font-size: 1.2rem;
  filter: drop-shadow(0 0 8px rgba(59, 130, 246, 0.8));
}

.info-item:hover .info-icon-wrapper {
  background: rgba(59, 130, 246, 0.4);
  transform: scale(1.1) rotate(5deg);
  border-color: #3b82f6;
}

.info-item:hover .info-icon-wrapper i {
  filter: drop-shadow(0 0 12px rgba(255, 255, 255, 0.9));
}

/* TRANSICIÓN HORIZONTAL (Slide X) */
.slide-x-enter-active, .slide-x-leave-active {
  transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}

.slide-x-enter-from, .slide-x-leave-to {
  transform: translateX(100%);
}

/* Ajustes Responsivos */
@media (max-width: 992px) {
  .main-bg {
    filter: blur(4px); /* Desenfoque extra para que el login sea el rey */
    transform: scale(1.1); /* Evita bordes blancos por el blur */
  }
}

@media (max-width: 1024px) {
  .welcome-layer { padding-left: 5%; }
  .brand-title { font-size: clamp(2.5rem, 8vw, 4rem); }
  .brand-slogan { font-size: 1.1rem; }
}

@media (max-width: 768px) {
  .welcome-layer { 
    padding: 4rem 1.5rem; /* Más espacio arriba y abajo para que respire */
    align-items: flex-start; /* En móvil empezamos desde arriba para poder usar el scroll */
    justify-content: center;
    text-align: center;
    min-height: 100vh; /* Asegura que el fondo cubra todo */
  }
  .welcome-layer.mobile-hidden {
    display: none;
  }
  .welcome-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  /* Reducimos el tamaño del título en móviles pequeños para que no ocupe 3 líneas */
  .brand-title { 
    font-size: clamp(2.2rem, 10vw, 3.5rem) !important; 
    margin-bottom: 1rem !important;
  }
  /* Ajustamos los cuadros para que sean más compactos en móvil */
  .system-info-grid {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)) !important;
    gap: 10px !important;
    width: 100%;
    max-width: 350px;
  }
  .info-item { 
    padding: 12px !important;
    text-align: left; 
  }
  .brand-tag { justify-content: center; font-size: 0.9rem; }
  .brand-slogan { border-left: none; border-top: 3px solid #3b82f6; padding-left: 0; padding-top: 1rem; }
  .login-panel { width: 100%; border-left: none; background: rgba(0, 10, 20, 0.98); }
  .login-box { width: 100%; max-width: 450px; }
  .btn-reveal-login {
    width: 100%;
    max-width: 300px;
  }
}

.container-btn-ingresar {
  /* Forzamos 80px en PC y 40px en móvil */
  margin-top: 40px !important; 
  display: block;
  width: 100%;
}

@media (max-width: 768px) {
  .container-btn-ingresar {
    margin-top: 40px !important;
    padding-bottom: 2rem;
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>

<script>
import { ref } from "vue";
import { useAuth } from "../../composables/useAuth";
import { loading } from '@/plugins/loading';
import { alert } from '@/plugins/alert';

export default {
  setup() {
    const showLogin = ref(false); // <--- Solo mostramos el Welcome al entrar
    const email = ref("");
    const password = ref("");
    const { login } = useAuth();

    const handleLogin = async () => {
      loading.show('Iniciando sesión...');
      try {
        await login(email.value, password.value);
        loading.hide();
      } catch (error) {
        loading.hide();
        alert.toast({
          title: 'Acceso Denegado',
          text: 'Las credenciales no coinciden.',
          icon: 'error'
        });
      }
    };

    return { showLogin, email, password, login: handleLogin };
  },
};
</script>